import React, { useEffect, useState } from 'react';
import './category.scss';
import { getListCategory, getListGenre } from '../../shared/services/category/category-service';
import ImageGenerator from '../../components/image-generator/image-generator';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumb from '../../components/breadcrumb/breadcrumb';
import { setTitle } from '../../shared/services/general/general-service';

function CategoryPage (props) {
	const [isCategory, setIsCategory] = useState(true);
	const [categoryList, setCategoryList] = useState([]);
	const [genreList, setGenreList] = useState([]);
	const location = useLocation();
	const path = location.pathname;

	useEffect(() => {
		if (path.includes('/category')) {
			setIsCategory(true)
			getCategory()
			setTitle(`ببین | دسته بندی ها`);
		} else if (path.includes('/genre')) {
			setIsCategory(false)
			getGenre()
			setTitle(`ببین | ژانرها`);
		}
	}, []);

	const getCategory = () => {
		getListCategory().then(
			(res) => {
				if (res.data.code === 200) {
					setCategoryList(res.data.data);
				}
			},
		);
	};
	const getGenre = () => {
		getListGenre().then(
			(res) => {
				if (res.data.code === 200) {
					setGenreList(res.data.data);
				}
			},
		);
	};

	const renderCategory = () => {
		return (
			<>
				{categoryList?.map((categoryItem) => renderItem(categoryItem))}
			</>
		);
	};

	const renderGenre = () => {
		return (
			<>
				{genreList?.map((genreItem) => renderItem(genreItem))}
			</>
		);
	};

	function checkForSerial(str) {
		return str.includes("سریال") || (!str.includes("فیلم") && path.includes("series"));
	}

	const renderItem = (data) => {
		const result = checkForSerial(data?.value);
		return (
			<Link className='item' key={data.id}
				  to={`/t/${data?.tagDefinitionName}/${data.id}/${result ? 'series' : 'movies'}`}>
				<ImageGenerator src={data?.fields?.image}
								name={data?.value}/>
				<div className='title'>
					{data?.value}
				</div>
			</Link>
		);
	};

	const showResult = () => {
		return(
			<>
				<div style={{maxWidth: '1482px', width: 'calc(100% - 48px)'}}>
					<Breadcrumb
						firstItem={{ label: 'خانه', path: '/' }}
						currentItem={isCategory ? 'دسته بندی ها' : 'ژانرها'}
					/>
				</div>
				<div className='header'>
					<a className={(isCategory) ? 'active' : null} onClick={() => {
						setIsCategory(true);
						if (categoryList.length < 1) getCategory();
					} }>
						<span>دسته بندی ها</span>
					</a>
					<a className={(!isCategory) ? 'active' : null} onClick={() => {setIsCategory(false); if (genreList.length < 1) getGenre()}}>
						<span>ژانرها</span>
					</a>
				</div>
				<div className='warp'>
					{(isCategory) ? renderCategory() : renderGenre()}
				</div>
			</>
		);
	};


	return (
		<section className="category-container container">
			{showResult()}
		</section>
	);
}

export default CategoryPage;